var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{attrs:{"type":"hidden","name":_vm.input.name},domProps:{"value":_vm.input.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }